import React, { useState } from "react";

export default function FacilityRatingModal({
  open,
  worker,
  onSave,
  onClose,
}) {
  const [professionalism, setProfessionalism] = useState(5);
  const [communication, setCommunication] = useState(5);
  const [reliability, setReliability] = useState(5);
  const [clinicalSkills, setClinicalSkills] = useState(5);
  const [wouldRequestAgain, setWouldRequestAgain] = useState(true);

  if (!open) return null;

  function RatingRow(label, value, setter) {
    return (
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontWeight: 800, marginBottom: 6 }}>
          {label}
        </div>

        <select
          value={value}
          onChange={(e) => setter(Number(e.target.value))}
          style={{
            width: "100%",
            padding: 10,
            borderRadius: 10,
          }}
        >
          <option value={5}>★★★★★ Excellent</option>
          <option value={4}>★★★★ Very Good</option>
          <option value={3}>★★★ Good</option>
          <option value={2}>★★ Fair</option>
          <option value={1}>★ Poor</option>
        </select>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.45)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999,
      }}
    >
      <div
        style={{
          width: 500,
          maxWidth: "95%",
          background: "#fff",
          borderRadius: 20,
          padding: 24,
        }}
      >
        <h2>Rate Worker</h2>

        <div style={{ marginBottom: 20 }}>
          {worker?.displayName ||
            worker?.firstName ||
            worker?.email}
        </div>

        {RatingRow("Professionalism", professionalism, setProfessionalism)}

        {RatingRow("Clinical Skills", clinicalSkills, setClinicalSkills)}

        {RatingRow("Communication", communication, setCommunication)}

        {RatingRow("Reliability", reliability, setReliability)}

        <label
          style={{
            display: "flex",
            gap: 8,
            marginTop: 10,
            marginBottom: 20,
          }}
        >
          <input
            type="checkbox"
            checked={wouldRequestAgain}
            onChange={(e) =>
              setWouldRequestAgain(e.target.checked)
            }
          />

          Would request this worker again
        </label>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <button onClick={onClose}>
            Cancel
          </button>

          <button
            onClick={() =>
              onSave({
                professionalism,
                communication,
                reliability,
                clinicalSkills,
                wouldRequestAgain,
              })
            }
          >
            Save Rating
          </button>
        </div>
      </div>
    </div>
  );
}